export const DiscountType = Object.freeze({
  PERCENTAGE: "PERCENTAGE",
  FIXED_PER_RESERVATION: "FIXED_PER_RESERVATION",
  FIXED_PER_SEAT: "FIXED_PER_SEAT"
});
